import React from "react";
import Button from "../../../../../../_components/Button";
import { downaloadDANFE } from "../../../../../../api/nfe";
import { donwloadBase64 } from "../../../../../../utils";

export default (props) => {
  const [loading, setLoading] = React.useState(false);

  function downloadPDF() {
    setLoading(true);
    downaloadDANFE(props.nfe.id)
      .then((resp) => {
        const { key, data } = resp;
        donwloadBase64(key, "pdf", "application/pdf", data);
        setLoading(false);
      })
      .catch(() => setLoading(false))
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 400);
      });
  }
  return (
    <Button
      as="text"
      className="text-danger"
      title="Baixar DANFE"
      onClick={downloadPDF}
      disabled={props.nfe.status != 1 || loading}
    >
      {loading ? <i class="fas fa-spinner fa-pulse" /> : <i className="fas fa-file-pdf" />}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/DownloadPDF/index.jsx